/* Zivaria collection page: read-more, filter drawer, load more */
(() => {
  if (window.__zvColl) return;
  window.__zvColl = true;

  const init = (root) => {
    // Read more / less on the collection text
    const desc = root.querySelector('[data-zv-desc]');
    if (desc) {
      const text = desc.querySelector('.zv-coll__desc-text');
      const btn = desc.querySelector('[data-zv-more]');
      desc.classList.add('is-clamped');
      if (text.scrollHeight > text.clientHeight + 2) {
        btn.hidden = false;
        btn.addEventListener('click', () => {
          const open = desc.classList.toggle('is-clamped') === false;
          btn.setAttribute('aria-expanded', String(open));
          btn.querySelector('[data-more]').hidden = open;
          btn.querySelector('[data-less]').hidden = !open;
        });
      } else {
        desc.classList.remove('is-clamped');
      }
    }

    // Filter drawer
    const dialog = root.querySelector('[data-zv-filters]');
    root.querySelector('[data-zv-open-filters]')?.addEventListener('click', () => dialog?.showModal());
    root.querySelector('[data-zv-close-filters]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    // drop empty price fields so they don't become ?filter.v.price.gte=
    root.querySelector('[data-zv-filter-form]')?.addEventListener('submit', (e) => {
      e.currentTarget.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true; });
    });

    // Load more
    root.addEventListener('click', async (e) => {
      const link = e.target.closest('[data-zv-load-more]');
      if (!link) return;
      e.preventDefault();
      link.setAttribute('aria-busy', 'true');
      const label = link.textContent;
      link.textContent = link.dataset.labelLoading || label;
      try {
        const res = await fetch(link.href, { credentials: 'same-origin' });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = root.querySelector('[data-zv-grid]');
        const items = doc.querySelectorAll('[data-zv-grid] > li');
        items.forEach((li) => { li.classList.add('is-new'); grid.append(li); });
        const nextPager = doc.querySelector('[data-zv-pager]');
        const pager = root.querySelector('[data-zv-pager]');
        if (nextPager) pager.replaceWith(nextPager); else pager.remove();
        history.replaceState(null, '', link.href);
        items[0]?.querySelector('a')?.focus({ preventScroll: true });
      } catch (err) {
        window.location.href = link.href;
      }
    });
  };

  const start = () => document.querySelectorAll('[data-zv-coll]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
